import React, { useState, useEffect } from "react";

function Heading({ data }) {
  const [element, setElement] = useState({
    type: "heading",
    properties: {
      title: "Group Heading",
    },
  });

  useEffect(() => {
    setElement(data);
  }, [data]);

  return (
    <div className="form-builder-element col-md-12 heading">
      <button className="btn btn-primary float-right">Expand Section</button>
      <h2>{element.properties.title}</h2>
    </div>
  );
}

export default Heading;
